import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Python Poet Walkthrough`}</h1>
    <p>{`This video shows our working version of a Python Poet that follows the project requirements! `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "memo"
      }}>{`📝`}</span>{`
You can follow along if you get stuck, want ideas, or just want to compare your implementation to
ours.`}</p>
    <p>{`We chose to build a poet that writes Remember by Joy Harjo and then transforms it into backwards,
randomly, and alternating versions of the original lines.`}</p>
    <Video alt="Python Poet Walkthrough" videoId="wwvNVySW-t8" mdxType="Video" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      